import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { settingsService } from 'v2/shared/services/settings-service'
import { getAPIConsoleQueryKeys } from 'v2/shared/utils/query-key-management'
import type { UpdateVoiceSettingPayload } from './types'

export const useVoiceSettingsQuery = (subaccountAuthId?: string) => {
  return useQuery({
    queryKey: getAPIConsoleQueryKeys().voiceSettings(subaccountAuthId),
    queryFn: async () => {
      const response = await settingsService.getVoiceSettings(subaccountAuthId)
      return response.data
    },
    // voice_enabled gates the Verified Caller ID surface (see useVoiceAccessGate).
    // Always re-verify on mount so newly-granted access reflects without a manual
    // hard refresh — the global default (1-min staleTime + persisted cache) would
    // otherwise keep showing the "Request Access" card after access is granted.
    staleTime: 0,
    refetchOnMount: 'always',
  })
}

export const useUpdateVoiceSettingMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: UpdateVoiceSettingPayload) => {
      return settingsService.updateVoiceSettings(payload)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['api-console', 'voice-settings'],
      })
    },
  })
}
